module.exports = __webpack_public_path__ + "static/media/Calentadorenlinea.c3168998.png";